module.exports = __webpack_public_path__ + "03_mole.206427b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/03_mole.png
// module id = QaBw
// module chunks = 0